import { SwapDirection, SwapDirectionType } from './ActionsTableRow';

export const getSwapPosition = (
  position: number,
  direction: SwapDirectionType
) => position + (direction === SwapDirection.TOP ? -1 : 1);

export const getCurrentLevelClass = (
  row: HTMLTableRowElement | null,
  prefix: string
) => {
  return row?.className.split(' ').find((name) => name.startsWith(prefix));
};

export const findSiblingRow = (
  row: HTMLTableRowElement | null,
  levelClass: string | undefined,
  isMovingUp: boolean
): HTMLTableRowElement | null => {
  const action = isMovingUp ? 'previousElementSibling' : 'nextElementSibling';

  const findRecursively = (
    currentRow: HTMLTableRowElement | null
  ): HTMLTableRowElement | null => {
    const nextRow = currentRow?.[action];
    if (!nextRow || !levelClass) return null;

    if (
      nextRow instanceof HTMLTableRowElement &&
      nextRow.classList.contains(levelClass)
    ) {
      return nextRow;
    }

    return findRecursively(nextRow as HTMLTableRowElement);
  };

  return findRecursively(row);
};

export const getSwapClasses = (isTop: boolean) => {
  const swapClasses = ['row-swap-bottom', 'row-swap-top'];
  return isTop ? [swapClasses[1], swapClasses[0]] : swapClasses;
};
